<template>
  <div class="text-block">
    <p class="desktop">{{ textTitle }}</p>
    <p class="mobile">
      З нами ти зможеш долучитися до одного з підрозділів Сухопутних військ та
      опанувати найсучаснішу професію у війську – стати оператором БпЛА, НРК або
      іншим фахівцем безпілотних систем
    </p>
    <project-guarantee :guarantee-text="guaranteeText" />
    <custom-button-join class="button" />
  </div>
</template>

<script>
import CustomButtonJoin from "@/components/UI/CustomButtonJoin.vue";
import ProjectGuarantee from "@/components/main/aboutProject/modules/ProjectGuarantee.vue";

export default {
  name: "project-text-block",
  props: {
    textTitle: {
      type: String,
      default: () => "",
    },
    guaranteeText: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ProjectGuarantee,
    CustomButtonJoin,
  },
};
</script>

<style lang="scss" scoped>
.text-block {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 13px;
  justify-content: space-between;

  p {
    font-family: UAF Sans, serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    @media (max-width: 767px) {
      font-size: 18px;
    }

    @media (max-width: 1360px) {
      order: 2;
    }

    &.desktop {
      @media (max-width: 767px) {
        display: none;
      }
    }

    &.mobile {
      @media (min-width: 768px) {
        display: none;
      }
    }
  }

  .button {
    @media (max-width: 1360px) {
      order: 3;
    }
  }
}
</style>
